export const TNC_JS_TEMPLATE = `/* START TNCJS TRACKING - {{PROVIDER_NAME}} - ProviderID: {{PROVIDER_ID}} */
(function(t,n,c,i,d){t[c]=t[c]||{};t[c].providerId=i;t[c].options=t[c].options||d;
var f='ready';t[c][f]=t[c][f]||function(z){t[c][f].q=t[c][f].q||[];if(typeof z=='function')
{t[c][f].q.push(z);return t[c];}return new Promise(function(r){t[c][f].q.push(r)});};
var s=n.createElement('script');s.setAttribute('global',c);s.async=!0;
s.src='https://js.tncid.app/route.js';n.querySelector('head,body').appendChild(s);})
(window,document,'__tnc','{{PROVIDER_ID}}',{autostart:{{AUTOSTART}}});
/* END TNCJS TRACKING */`;
